import axios from 'axios';
import router from '@/router'
import { API_BASE_URL } from '@/config/runtime';

const CSRF_COOKIE_NAME = 'csrftoken';
const CSRF_HEADER_NAME = 'X-CSRFToken';

let store = null;
let isHandlingUnauthorized = false;

export const setStore = (s) => {
  store = s;
};

const session = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  withCredentials: false,
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
});

session.interceptors.response.use(function (response) {
  return response
}, function (error) {
  const status = error?.response?.status;
  const requestUrl = error?.config?.url;
  const isLoginRequest = requestUrl?.includes('/auth/login/');
  const isLogoutRequest = requestUrl?.includes('/auth/logout/');
  const isAdminNewsRequest = requestUrl?.includes('/admin_news/');
  const isSilentRequest = isLoginRequest || isLogoutRequest || isAdminNewsRequest || error?.config?.suppressErrorAlert;

  if (!error.response) {
    if (process.env.NODE_ENV !== 'production') {
      const errorType = error?.code === 'ECONNABORTED' ? 'timeout' : (error?.code || 'network');
      console.warn('[session] request failed without response', {
        type: errorType,
        method: error?.config?.method,
        url: requestUrl,
      });
    }
    return Promise.reject(error);
  }

  if (status === 500 || status === 404) {
    return Promise.reject(error);
  }

  if (status === 403) {
    if (store && !isSilentRequest)
      store.commit('notifications/raiseError', error.response.data);
    return Promise.reject(error);
  }

  if (store && !isSilentRequest && status !== 401)
    store.commit('notifications/raiseError', error.response.data);

  if (status === 401) {
    const token = store?.state?.auth?.token;
    const isAuthenticated = !!token;
    const isAuthenticating = !!store?.state?.auth?.authenticating;

    if (store && isAuthenticated && !isLoginRequest && !isLogoutRequest && !isHandlingUnauthorized && !isAuthenticating) {
      isHandlingUnauthorized = true;
      try {
        store.commit('auth/LOGOUT');
        store.commit('auth/REMOVE_TOKEN');
        if (router.currentRoute.path !== '/login') {
          router.push('/login');
        }
      } finally {
        isHandlingUnauthorized = false;
      }
    }
  }

  return Promise.reject(error);
})


export default session;

